import { render, staticRenderFns } from "./NormalPost.vue?vue&type=template&id=1abfc824"
import script from "./NormalPost.vue?vue&type=script&lang=js"
export * from "./NormalPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports